import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMarkupMeasureLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M21 12C21 13.3807 19.8807 14.5 18.5 14.5C17.1193 14.5 16 13.3807 16 12C16 10.6193 17.1193 9.5 18.5 9.5C19.8807 9.5 21 10.6193 21 12Z",
			fill: "#C8C8C8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 12C8 13.3807 6.88071 14.5 5.5 14.5C4.11929 14.5 3 13.3807 3 12C3 10.6193 4.11929 9.5 5.5 9.5C6.88071 9.5 8 10.6193 8 12Z",
			fill: "#C8C8C8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 12H17M21 12C21 13.3807 19.8807 14.5 18.5 14.5C17.1193 14.5 16 13.3807 16 12C16 10.6193 17.1193 9.5 18.5 9.5C19.8807 9.5 21 10.6193 21 12ZM8 12C8 13.3807 6.88071 14.5 5.5 14.5C4.11929 14.5 3 13.3807 3 12C3 10.6193 4.11929 9.5 5.5 9.5C6.88071 9.5 8 10.6193 8 12Z",
			stroke: "currentColor",
			strokeWidth: 2
		})
	]
});
export default SvgMarkupMeasureLine;
